import BaseModel from "../base_model.js.jsx";

import InvestmentStatusEnum from "../../enums/investment_status.js.jsx";
import InvestmentActivityStatusEnum from "../../enums/investment_activity_status.js.jsx";

class RawProjectEditInvestmentModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "status",
        displayName: this.fieldDisplayName("status"),
        type: "enum",
        enum: InvestmentStatusEnum,
      },
      {
        name: "activityStatus",
        displayName: this.fieldDisplayName("activityStatus"),
        type: "enum",
        enum: InvestmentActivityStatusEnum,
      },
    ]
  }

  i18nScope() {
    return "model.projects.investment";
  }

}
const ProjectEditInvestmentModel = new RawProjectEditInvestmentModel();

export { RawProjectEditInvestmentModel, ProjectEditInvestmentModel }

